import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ExperimentContext from './ExperimentContext';
import { logExperiment } from '@homeaway/abacus-client-utils';

const errorMsg = (name) => {
  /* istanbul ignore next */
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(`[Abacus] Missing experiment: ${name}.`);
  }
};

class ExperimentProvider extends Component {
  static propTypes = {
    experiments: PropTypes.shape({})
  }

  constructor(props) {
    super(props);

    this.exposedExperiments = [];
    this.experiments = props.experiments;

    this.publicMethods = {
      getExperiment: this.getExperiment,
      getExperimentValue: this.getExperimentValue,
      visibilityHandler: this.visibilityHandler,
      exposeExperiment: this.exposeExperiment
    };
  }

  updateExposedTests = (experimentName) => {
    this.exposedExperiments.push(experimentName);
  }

  getExperimentValue = (name) => {
    const experiment = this.experiments[name];
    let value;

    if (!experiment) {
      errorMsg(name);
      value = null;
    } else {
      value = experiment.value;
    }

    return value;
  }

  getExperiment = (name) => {
    return this.experiments[name] || null;
  }

  visibilityHandler = experimentName => (isVisible) => {
    if (isVisible) {
      this.exposeExperiment(experimentName);
    }
  }

  exposeExperiment = (experimentName) => {
    if (!this.exposedExperiments.includes(experimentName)) {
      logExperiment(experimentName);
      this.updateExposedTests(experimentName);
    }
  }

  render() {
    return (
      <ExperimentContext.Provider value={this.publicMethods}>
        {this.props.children}
      </ExperimentContext.Provider>
    );
  }
}

const mapStateToProps = ({ abacus }) => ({
  experiments: abacus.experiments
});

export default connect(mapStateToProps, null, null)(ExperimentProvider);
